import { onSnapshot, type QuerySnapshot } from "firebase/firestore";
import { planRoomElementsCol } from "@/features/seating/firestore-paths";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import { parsePlanScopedKey } from "@/lib/firestore/subscription-keys";
import type { RoomElement } from "@amazing-wedding/shared-types";

function parseRoomElements(snap: QuerySnapshot): RoomElement[] {
  const rows: RoomElement[] = [];
  snap.forEach((d) => {
    const data = d.data() as Omit<RoomElement, "id">;
    rows.push({ id: d.id, ...data });
  });
  return rows;
}

export const roomElementsSubscription = createSharedSubscription<RoomElement[]>({
  getDefault: () => [],
  attach: (key, setSnapshot) => {
    const scoped = parsePlanScopedKey(key);
    if (!scoped) {
      setSnapshot({ data: [], loading: false });
      return () => {};
    }

    setSnapshot({ data: [], loading: true });
    return onSnapshot(
      planRoomElementsCol(scoped.weddingId, scoped.planId),
      (snap) => {
        setSnapshot({ data: parseRoomElements(snap), loading: false });
      },
      () => setSnapshot({ data: [], loading: false }),
    );
  },
});
